import React from 'react';
import { useTranslation } from 'react-i18next';
import { setInterfaceLanguage } from '../../i18n';
import '../../styles/languageSwitcher.scss';

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation('common');
  const language = i18n.resolvedLanguage || 'pl';
  return (
    <div className="interface-language">
      <i className="fas fa-globe" aria-hidden="true" />
      <span aria-hidden="true">{language.toUpperCase()}</span>
      <select aria-label={t('language.label')} value={language} onChange={event => setInterfaceLanguage(event.target.value, i18n)}>
        <option value="pl">Polski</option>
        <option value="en">English</option>
      </select>
    </div>
  );
}
